import axios from "axios";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";
import axiosInstance from "../../../Hooks/axoisInstance";

const getToken = () => {
    return localStorage.getItem("token");
  };
export const getAllCircleZoneWiseReport = async (requestData) => {
    try {
        const { Date, OwnerTypeId,VehicleTypeId, ShiftId } = requestData;
        const response = await axiosInstance.get(API_BASE_URL1 + `SCVReport/ReportedSCVatCircleZoneWiseReport?Date=${Date}&OwnerTypeId=${OwnerTypeId}&VehicleTypeId=${VehicleTypeId}&ShiftId=${ShiftId}`,
           {
            headers: {
                Authorization: `Bearer ${getToken()}`
            },
            
        },
        
        );
        return response;
    } catch (error) {
        throw error
    }
};
 
export const getAllCircleWiseReportCircle = async (requestData) => {
    try {
        const { Date,OwnerTypeId,zoneId, ShiftId,VehicleTypeId } = requestData;
        const response = await axiosInstance.get(API_BASE_URL1 + `SCVReport/ReportedSCVatCircleCircleWiseReport?Date=${Date}&OwnerTypeId=${OwnerTypeId}&zoneId=${zoneId}&ShiftId=${ShiftId}&VehicleTypeId=${VehicleTypeId}`, {
            
            headers: {
                Authorization: `Bearer ${getToken()}`
            },
        });
        return response;
    } catch (error) {
        throw error
    }
};